import './polyfill';
import {bootstrap} from './bootstrap';
import './styles';   // To make sure the styles are included and processed in webpack

$( document ).ready(function() {
    bootstrap();
});